import { render } from "./LoadingScreenComponent.vue?vue&type=template&id=f8fb8f72&scoped=true"
const script = {}

import "./LoadingScreenComponent.vue?vue&type=style&index=0&id=f8fb8f72&scoped=true&lang=css"

import exportComponent from "/Users/alejandrobernal/Documents/fbc/fbc-ecommerce-main-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8fb8f72"]])

export default __exports__